// Inlined AudioWorklet processor source. We Blob-URL it at runtime to avoid
// asking the bundler to handle a separate worklet entry point.
export const PCM_WORKLET_SOURCE = `
class PcmCaptureProcessor extends AudioWorkletProcessor {
  process(inputs) {
    const input = inputs[0];
    if (input && input[0] && input[0].length) {
      const copy = new Float32Array(input[0]);
      this.port.postMessage(copy.buffer, [copy.buffer]);
    }
    return true;
  }
}
registerProcessor('pcm-capture', PcmCaptureProcessor);
`;
